
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/video-testimonials",
      function () {
        return require("private-next-pages/world/video-testimonials.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/video-testimonials"])
      });
    }
  